import '@forest/native-diagnostics'

import './lib/posthog'
import {
  getProducts,
  getReceiptSystemAccountIdSafe,
  initializeNativeBridge,
  native,
  type Products,
} from '@forest/native-services'
import { getChinaAndroidTrialEligibility } from './lib/get-china-android-trial-eligibility'
import { defineCustomClientStrategy } from './paraglide/runtime'
import { appVersion, language, platform } from './params'
import { api } from './services/api'
import { $receiptSystemAccountId } from './store/receipt-system-account-id'
import { $chinaAndroidTrialEligibility, setProduct } from './store'
import { userInfoSource } from './store/user-info'

defineCustomClientStrategy('custom-queryParam', {
  getLocale: () => language,
  setLocale: () => {},
})

initializeNativeBridge({
  bifrost: { enableDebug: import.meta.env.MODE !== 'production' },
})

void getReceiptSystemAccountIdSafe(appVersion).then((id) => {
  $receiptSystemAccountId.set(id)
})

const userInfoPromise = userInfoSource.getReady()
const productsPromise = getProducts({
  cacheKeyPrefix: 'allowlistPaywall.products.v2',
  api,
  appVersion,
  platform,
  deferredUserInfo: userInfoPromise,
  env: import.meta.env.MODE as 'production' | 'staging' | 'dev',
  shouldMock: import.meta.env.DEV,
})

function productIdsOf(products: Products): string {
  return [
    products.annualOriginal.product_id,
    products.annualEarlyBird.product_id,
    products.monthlyOriginal.product_id,
    products.monthlyEarlyBird.product_id,
  ]
    .concat(products.monthlyNoTrial ? [products.monthlyNoTrial.product_id] : [])
    .sort((a, b) => a - b)
    .join(',')
}

if (import.meta.env.DEV) {
  if (platform === 'china_android') {
    $chinaAndroidTrialEligibility.set('unavailable')
  }

  productsPromise
    .then((products) => {
      setProduct(products.annualEarlyBird)
      native.general.logEvent({
        event_name: 'plus_price_test_config',
        event_params: { product_ids: productIdsOf(products) },
      })
    })
    .catch(() => {
      native.general.close()
    })
} else {
  ;(async function init() {
    try {
      const userInfo = await userInfoPromise

      const [products] = await Promise.all([
        productsPromise,
        getChinaAndroidTrialEligibility(userInfo.user_id),
      ])
      setProduct(products.annualEarlyBird)
      native.general.logEvent({
        event_name: 'plus_price_test_config',
        event_params: { product_ids: productIdsOf(products) },
      })
    } catch {
      native.general.close()
    }
  })()
}

native.general.pageReady()
